/** Max bar height from Figma Frame 1000004428 / 4429 (303px). */
export const ADJUSTS_CREDITS_DEMAND_MAX_BAR_HEIGHT = 303;

export const ADJUSTS_CREDITS_DEMAND_BAR_WIDTH = 216;
export const ADJUSTS_CREDITS_DEMAND_BAR_GAP = 64;
export const ADJUSTS_CREDITS_DEMAND_LABEL_GAP = 16;
export const ADJUSTS_CREDITS_DEMAND_BAR_RADIUS = 16;

export const ADJUSTS_CREDITS_DEMAND_TRANSITION_MS = 800;
export const ADJUSTS_CREDITS_DEMAND_FRAME_MS = 800;
export const ADJUSTS_CREDITS_DEMAND_PEAK_HOLD_MS = 1500;

/**
 * Animation timeline from Figma component set "Demand animation - desktop" (13142:36234).
 * Prototype loop: 4427 → 4428 → 4429 → 4431 → 4432 → 4427
 */
export const ADJUSTS_CREDITS_DEMAND_ANIMATION_FRAMES = Object.freeze([
  Object.freeze({
    figmaVariant: 'Frame 1000004427',
    demandHeight: 190,
    creditHeight: 152,
    demandActive: false,
    creditActive: false,
    holdMs: ADJUSTS_CREDITS_DEMAND_FRAME_MS,
  }),
  Object.freeze({
    figmaVariant: 'Frame 1000004428',
    demandHeight: 303,
    creditHeight: 152,
    demandActive: true,
    creditActive: false,
    holdMs: 1000,
  }),
  Object.freeze({
    figmaVariant: 'Frame 1000004429',
    demandHeight: 303,
    creditHeight: 257,
    demandActive: true,
    creditActive: true,
    holdMs: ADJUSTS_CREDITS_DEMAND_PEAK_HOLD_MS,
  }),
  Object.freeze({
    figmaVariant: 'Frame 1000004431',
    demandHeight: 175,
    creditHeight: 257,
    demandActive: false,
    creditActive: true,
    holdMs: ADJUSTS_CREDITS_DEMAND_PEAK_HOLD_MS,
  }),
  Object.freeze({
    figmaVariant: 'Frame 1000004432',
    demandHeight: 175,
    creditHeight: 152,
    demandActive: false,
    creditActive: false,
    holdMs: ADJUSTS_CREDITS_DEMAND_FRAME_MS,
  }),
]);

export const ADJUSTS_CREDITS_DEMAND_REDUCED_MOTION_FRAME = ADJUSTS_CREDITS_DEMAND_ANIMATION_FRAMES.find(
  frame => frame.figmaVariant === 'Frame 1000004429'
);

export const barHeightPercent = height => `${((height / ADJUSTS_CREDITS_DEMAND_MAX_BAR_HEIGHT) * 100).toFixed(4)}%`;
